// DESCRIPTION: BlockInfo related models & functions

(function (mod){ //[HyperMD] UMD patched!
  /*commonjs*/  ("object"==typeof exports&&"undefined"!=typeof module) ? mod(null, exports, require("../attributes/index")) :
  /*amd*/       ("function"==typeof define&&define.amd) ? define(["require","exports","../attributes/index"], mod) :
  /*plain env*/ mod(null, (this.HyperMD.BlockInfoNormalize = this.HyperMD.BlockInfoNormalize || {}), HyperMD.AttributesAddon);
})(function (require, exports, index_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    function default_1(blockInfo) {
        var normalizedAttributes = index_1.normalizeAttributes(blockInfo.attributes);
        var normalizedLanguage = normalizeLanguage(blockInfo.language);
        if (normalizedAttributes !== blockInfo.attributes ||
            normalizedLanguage !== blockInfo.language) {
            return {
                language: normalizedLanguage,
                attributes: normalizedAttributes
            };
        }
        return blockInfo;
    }
    exports.default = default_1;
    var normalizeLanguage = function (language) {
        if (typeof language === "string") {
            return language.trim().toLowerCase();
        }
        return "";
    };
});
